import { useEffect, useState } from "react";
import { MapPin, Instagram } from "lucide-react";
import { api } from "../lib/api";
import { BackgroundTexture } from "../components/BackgroundTexture";
import { Footer } from "../components/Footer";

export default function ContactPage() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    api.getSettings().then((s) => setSettings(s.data)).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.submitContact(form);
      setStatus({ type: "success", message: "Message sent. We'll be in touch." });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      setStatus({ type: "error", message: "Something went wrong." });
    }
  };

  return (
    <div data-testid="contact-page" className="min-h-screen content-layer">
      <BackgroundTexture />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 lg:py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          <div>
            <p className="text-[11px] font-medium tracking-[0.15em] text-white/60 uppercase mb-2">Reach Out</p>
            <h1 className="font-syne text-3xl lg:text-4xl font-semibold text-white mb-6">Contact</h1>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-white/70 uppercase tracking-wider mb-2">Name</label>
                <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="contact-name" className="input-on-orange w-full px-4 py-3 text-sm rounded-md" />
              </div>
              <div>
                <label className="block text-xs font-medium text-white/70 uppercase tracking-wider mb-2">Email</label>
                <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="contact-email" className="input-on-orange w-full px-4 py-3 text-sm rounded-md" />
              </div>
              <div>
                <label className="block text-xs font-medium text-white/70 uppercase tracking-wider mb-2">Phone (Optional)</label>
                <input type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" className="input-on-orange w-full px-4 py-3 text-sm rounded-md" />
              </div>
              <div>
                <label className="block text-xs font-medium text-white/70 uppercase tracking-wider mb-2">Message</label>
                <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required rows={5} data-testid="contact-message" className="input-on-orange w-full px-4 py-3 text-sm rounded-md resize-none" />
              </div>
              <button type="submit" data-testid="contact-submit" className="btn-dark px-8 py-4 text-sm font-medium rounded-md">
                Send Message
              </button>
              {status.message && (
                <p className={`text-sm ${status.type === "success" ? "text-white" : "text-red-300"}`}>{status.message}</p>
              )}
            </form>
          </div>

          <div className="panel-light p-8 lg:p-10 rounded-md h-fit">
            <h3 className="font-syne text-lg font-semibold text-[#2D1810] mb-6">Get In Touch</h3>
            <div className="space-y-5 text-sm">
              {settings?.address && (
                <div className="flex items-start gap-3">
                  <MapPin size={16} className="text-[#A04D1F] mt-0.5" />
                  <div>
                    <p className="text-xs text-[#2D1810]/40 uppercase tracking-wider mb-1">Address</p>
                    <p className="text-[#2D1810]/70">{settings.address}</p>
                  </div>
                </div>
              )}
 
              {settings?.instagram_url && (
                <div className="flex items-start gap-3">
                  <Instagram size={16} className="text-[#A04D1F] mt-0.5" />
                  <div>
                    <p className="text-xs text-[#2D1810]/40 uppercase tracking-wider mb-1">Instagram</p>
                    <a href={settings.instagram_url} target="_blank" rel="noopener noreferrer" className="text-[#2D1810]/70 hover:text-[#2D1810] transition-colors">@rrovgoa</a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer settings={settings} />
    </div>
  );
}
